import {FC} from "react";
import Breadcrumb from "./Breadcrumb";
import OpDetails from "./OpDetails";
import UserDetails from "./UserDetails";
import { IWaitingListRecord } from "../survey/SurveyModel/types/nodeTypes";

type PoaHeaderProps = {
    waitingListRecord: IWaitingListRecord | null;
    isLoading: boolean;
    onClickComplete: () => void;
    completeButtonEnabled?: boolean;
    isPdfGenerating?: boolean;
}

const PoaHeader:FC<PoaHeaderProps> = ({ waitingListRecord, isLoading, onClickComplete, completeButtonEnabled, isPdfGenerating }) => {
    return <div className="poa-header">
        <Breadcrumb name={`${waitingListRecord?.forename || ""} ${waitingListRecord?.surname || ""}`} onClickComplete={onClickComplete} completeButtonEnabled={completeButtonEnabled} isPdfGenerating={isPdfGenerating} />
        <UserDetails isLoading={isLoading} waitingListRecord={waitingListRecord} />
        <OpDetails isLoading={isLoading} waitingListRecord={waitingListRecord} />
    </div>
};

export default PoaHeader;